define('modules/user/user_model',[
  'backbone', '_', 'session'
], function (Backbone, _, session) {
  'use strict';
  var Model = Backbone.Model.extend({
    initialize: function () {
      _.mixin({
        'capability': this.capability.bind(this)
      });
    },

    defaults: {
      id: null,
      full_name: undefined,
      display_name: undefined,
      email: undefined,
      forgot_password: undefined,
      password_reset: undefined
    },

    url: function () {
      var url = session.get('apiUrl') + 'user';

      if (this.has('forgot_password')) {
        url += '/forgot_password';
      } else if (this.has('token')) {
        url += '/change_password';
      }

      return url;
    },

    capability: function (context, capability) {
      if (this.get('capabilities')[context] && this.get('capabilities')[context][capability]) {
        return this.get('capabilities')[context][capability];
      } else {
        return false;
      }
    }

  });

  var user = new Model();
  return user;
});

